import { Env } from '@/utils/env';

interface FeatureFlags {
  dna_relation_messages: boolean;
  reports_admin_actions: boolean;
  asidePanelsResize: boolean;
  headerLanguageSelect: boolean;
  supplyChainEmbeddedApp: boolean;
  intelligenceDashboardEmbeddedApp: boolean;
  colorTheme: boolean;
}

type FeatureFlag = keyof FeatureFlags;

const defaultFeatureFlags: FeatureFlags = {
  dna_relation_messages: false,
  reports_admin_actions: !Env.isProdDeployment(),
  asidePanelsResize: !Env.isProdDeployment(),
  headerLanguageSelect: !Env.isProdDeployment(),
  supplyChainEmbeddedApp: true,
  intelligenceDashboardEmbeddedApp: true,
  colorTheme: !Env.isProdDeployment(),
};

export class RolloutService {
  private featureFlags: Map<string, boolean>;

  constructor() {
    this.featureFlags = new Map(Object.entries({ ...defaultFeatureFlags }));
  }

  private isProdEnv(): boolean {
    return Env.isProdDeployment();
  }

  private isFeatureEnabled(featureName: FeatureFlag): boolean {
    return this.featureFlags.get(featureName) ?? false;
  }

  isLinkedDocsHighlightAvailable = () => {
    return !this.isProdEnv();
  };

  isReportsAdminActionsEnabled = () => {
    return this.isFeatureEnabled('reports_admin_actions');
  };

  isAsidePanelsResizeEnabled = () => {
    return this.isFeatureEnabled('asidePanelsResize');
  };

  isHeaderLanguageSelectEnabled = () => {
    return this.isFeatureEnabled('headerLanguageSelect');
  };

  isEmbeddedSupplyChainAppEnabled = () => {
    return this.isFeatureEnabled('supplyChainEmbeddedApp');
  };

  isIntelligenceDashboardEmbeddedAppEnabled = () => {
    return this.isFeatureEnabled('intelligenceDashboardEmbeddedApp');
  };

  isColorThemeEnabled = () => {
    return this.isFeatureEnabled('colorTheme');
  };
}

export const rolloutService = new RolloutService();
